import { render } from "./MyStore.vue?vue&type=template&id=96e7e2ea&scoped=true"
import script from "./MyStore.vue?vue&type=script&lang=js"
export * from "./MyStore.vue?vue&type=script&lang=js"

import "./MyStore.vue?vue&type=style&index=0&id=96e7e2ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e7e2ea"]])

export default __exports__